import { render, staticRenderFns } from "./ModalTeacherSkillInfo.vue?vue&type=template&id=31324112&scoped=true&"
import script from "./ModalTeacherSkillInfo.vue?vue&type=script&lang=js&"
export * from "./ModalTeacherSkillInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalTeacherSkillInfo.vue?vue&type=style&index=0&id=31324112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31324112",
  null
  
)

export default component.exports